<template>
<!-- This example requires Tailwind CSS v2.0+ -->
<div class="fixed z-10 inset-0 overflow-y-auto" :class="showModal?'':'hidden'" aria-labelledby="modal-title" role="dialog" aria-modal="true">
  <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
    <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>

    <!-- This element is to trick the browser into centering the modal contents. -->
    <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

    <div class="inline-block align-bottom bg-gray-700 rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-7xl sm:w-full">

    <section class="border border-gray-800 p-3">
        <div class="flex justify-between">
            <h4 class="text-white text-sm font-bold uppercase mb-3">Create {{ featureName }} feature</h4>
            <span v-if="$page.props.errors" v-for="err in Object.values($page.props.errors)" class="errormessage font-bold">{{ err }}</span>
            <button type="button" class="close" @click.prevent="closeModal">
              <span>&times;</span>
            </button>
        </div>
    </section>

    <div class="flex lang-box mt-5">
        <a v-for="(lang, index) in languages" href="#" @click.prevent="changeLanguage(lang)" :key="index"
        :class="{active:(form.current_language == lang), disabled:langDisabled(lang)}">{{ showFallbackLang(lang) }}</a>
    </div>
    <CreateFileInsideFeatureVideoSection
    :form="form" :saveFile="saveFile"
    :changeUploadBoxState="changeUploadBoxState"
    />

    </div>
  </div>
</div>
</template>

<script>
import CreateFileInsideFeatureVideoSection from '@/Pages/Station/Partials/Features/Video/CreateFileInsideFeatureVideoSection';
import { showFallbackLang } from '@/Pages/GlobalHelpers';

export default {
    components: {
        CreateFileInsideFeatureVideoSection,
    },
    props: ['showModal', 'closeModal', 'featureName', 'changeUploadBoxState', 'form'],
    data(){
        return {
            languages: this.$page.props.tour.data.languages,
        }
    },
    mounted(){
        this.changeLanguage(this.$page.props.tour.data.fallback_language);
    },
    methods: {
        saveFile() {
            this.form.post(route('videofeature.store', this.$page.props.station.data.id), {
              preserveScroll: true,
              onSuccess: () => this.closeModal(),
            });
        },
        changeLanguage(lang){
            if(this.langDisabled(lang))
            {
                return;
            }
            this.form.current_language = lang;
        },
        langDisabled(lang){
            if(lang == this.form.current_language)
            {
                return false;
            }
            if(this.form.feature_video_files.languages[this.form.fallback_language].loaded_file_path.length > 0)
            {
                return false;
            }
            return true;
        },
        showFallbackLang:showFallbackLang
    }
}
</script>
